export const transformData = (data, docs) => {
  const transformedData = [];
  docs.forEach((doc) => {
    const newDoc = { ...doc };
    delete newDoc._id;
    if (doc.text_required) {
      newDoc["text"] = data[`${doc.doc_name}_text`];
    }

    if (doc.doc_file) {
      newDoc["file"] = data[`${doc.doc_name}_file`];
    }
    transformedData.push(newDoc);
  });
  return transformedData;
};
